import { PipeTransform, Pipe } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({name: 'company'})
export class CompanyPipe implements PipeTransform {
  transform(value: string): string {
    return environment.admin.companies[value] || value;
  }
}
